module.exports = __webpack_public_path__ + "static/img/66053J_2_3_R_20190322_LC.6b82723.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/66053J_2_3_R_20190322_LC.png
// module id = Oi9h
// module chunks = 0